/**
 * 抖音来客商户ID 绑定
 *
 * 渠道物料（商品卡片）与渠道授权页的「授权来客」共用同一套弹框与接口，
 * 抽在这里避免两处各写一遍。
 */
import { ElMessage, ElMessageBox } from 'element-plus';
import { channelMaterialsApi } from '@/api';

export function useDyLifeBind() {
  /**
   * 弹框输入来客商户ID并绑定，成功返回 true，用户取消返回 false。
   *
   * 有意例外（CLAUDE.md「非必要不加 try/catch」）：ElMessageBox 在取消 / 关掉弹框时走 reject，
   * 不接住会冒成未处理的 rejection，被前端监控当成异常报出去。
   */
  async function bindDyLifeAccount(accountId: number): Promise<boolean> {
    const input = await ElMessageBox.prompt('请输入抖音来客生活服务账号 ID', '授权来客商户ID', {
      confirmButtonText: '绑定',
      cancelButtonText: '取消',
      inputPattern: /^\S+$/,
      inputErrorMessage: '请输入有效的账号 ID',
    }).catch(() => null);
    if (!input) return false;
    await channelMaterialsApi.dyLifeBindAccount({
      account_id: accountId,
      life_account_id: input.value,
    });
    ElMessage.success('绑定成功');
    return true;
  }

  return { bindDyLifeAccount };
}
